
import Vue from "vue";
import { BrowseStateBase } from "@/utils/browse/browse-state-base";

const LIMIT = 5;

export default Vue.extend({
	props: {
		item: {
			type: Object as () => any,
			required: true
		},
		state: {
			type: Object as () => BrowseStateBase,
			required: true
		}
	},
	computed: {
		loaded():boolean {
			return this.state.sidebarItemLoaded;
		},
		allEvents():any[] {
			let history:any[] = [...(this.item.History || [])];
			return history.sort((a, b)=>{
				if (a.Pinned != b.Pinned) return a.Pinned ? -1 : 1;
				return new Date(b.TimeStamp).getTime() - new Date(a.TimeStamp).getTime();
			});
		},
		events():any[] {
			return this.allEvents.slice(0, LIMIT);
		},
		hiddenCount():number {
			return Math.max(0, this.allEvents.length - LIMIT);
		},
		summary():string {
			let last = this.allEvents[0];
			if (!last) return "";
			return `${last.ComputedProps.title} · ${last.getTimeStampString()}`;
		}
	},
	watch: {
		summary: {
			immediate: true,
			handler(){
				this.$emit("summary", this.summary);
			}
		},
		item(){
			this.$emit("summary", this.summary);
		}
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
